import http from "./http";
import apis from "../config/apis.json";

const api =
  process.env.REACT_APP_ENVIRON === "development"
    ? apis.dev
    : process.env.REACT_APP_ENVIRON === "production"
    ? apis.prod
    : apis.test;

const base = (orgId) => `${api}/api/analyst-session/${orgId}`;

// Sessions
export async function getSessions(organizationId) {
  return http.get(base(organizationId));
}

export async function getSession(organizationId, sessionId) {
  return http.get(`${base(organizationId)}/${sessionId}`);
}

export async function createSession(organizationId, data) {
  return http.post(base(organizationId), data);
}

export async function updateSession(organizationId, sessionId, data) {
  return http.put(`${base(organizationId)}/${sessionId}`, data);
}

export async function deleteSession(organizationId, sessionId) {
  return http.delete(`${base(organizationId)}/${sessionId}`);
}

// Sheets within a session
export async function addSheet(organizationId, sessionId, data) {
  return http.post(`${base(organizationId)}/${sessionId}/sheet`, data);
}

export async function updateSheet(organizationId, sessionId, sheetId, data) {
  return http.put(`${base(organizationId)}/${sessionId}/sheet/${sheetId}`, data);
}

export async function removeSheet(organizationId, sessionId, sheetId) {
  return http.delete(`${base(organizationId)}/${sessionId}/sheet/${sheetId}`);
}
